import { render, staticRenderFns } from "./ot-standard-header-wrapper.vue?vue&type=template&id=6c6dcd0c&scoped=true&"
import script from "./ot-standard-header-wrapper.vue?vue&type=script&lang=ts&"
export * from "./ot-standard-header-wrapper.vue?vue&type=script&lang=ts&"
import style0 from "./ot-standard-header-wrapper.vue?vue&type=style&index=0&id=6c6dcd0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6dcd0c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
